module.exports = __webpack_public_path__ + "img/rlc.39328355.svg";